import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormControl} from "@angular/forms";
import {Apollo} from "apollo-angular";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";
import {update_acq_notes, update_synd_notes} from "./graphql/alterNotes";

const UPDATE_ACQ_NOTES = update_acq_notes;
const UPDATE_SYND_NOTES = update_synd_notes;
@Component({
    selector: 'deal-notes',
    templateUrl: './notes.component.html',
    styleUrls: ['./notes.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class NotesComponent implements OnInit{
 @Input() acquisitions: string;
 @Input() syndications: string;
 @Input() permissions: any;
 @Input() projectID: string;
 @Input() projectDetailID: String;

  acqNotesEditMode: boolean = false;
  acq: FormControl;
  acqChanged: boolean = false;

  syndNotesEditMode: boolean = false;
  synd: FormControl;
  syndChanged: boolean = false;

  constructor(private apollo: Apollo,
              private _snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.acq = new FormControl(this.acquisitions);
    this.synd = new FormControl(this.syndications);
  }

  toggleAcqNotesEditMode(){
    if(this.acqNotesEditMode && this.acqChanged){
      this.apollo
        .mutate({
          mutation: UPDATE_ACQ_NOTES,
          variables: {
            id: this.projectID,
            notes: this.acq.value
          },
        })
        .subscribe(
          ({ data }) => {
            // @ts-ignore
            this.acquisitions = data.updateNotes.notes;
            this.acq.setValue(this.acquisitions);
            this.acqChanged = false;
            this.openSnackBar();
          }
        );
    }
    this.acqNotesEditMode = !this.acqNotesEditMode;
  }

  toggleSyndNotesEditMode(){
    if(this.syndNotesEditMode && this.syndChanged){
      this.apollo
        .mutate({
          mutation: UPDATE_SYND_NOTES,
          variables: {
            id: this.projectDetailID,
            syndications_notes: this.synd.value
          },
        })
        .subscribe(
          ({ data }) => {
            // @ts-ignore
            this.syndications = data.updateSyndicationsNotes.syndications_notes;
            this.synd.setValue(this.syndications);
            this.syndChanged = false;
            this.openSnackBar();
          }
        );
    }
    this.syndNotesEditMode = !this.syndNotesEditMode;
  }

  openSnackBar() {
    const config = new MatSnackBarConfig();
    config.panelClass = ['save-success'];
    config.horizontalPosition = "center";
    config.verticalPosition = "top";
    config.duration = 3000;
    this._snackBar.open('Data saved successfully.', 'Ok', config);
  }
}
